import React from 'react'

export default props => <svg
  width="13" height="8"
  viewBox="0 0 13 8"
  fill="#909AAA"
  {...props}
>
  <path
    d="M6.5 0L12.1292 6H0.870835L6.5 0Z"
    transform="translate(13 8) rotate(180)"
    //fill="url(#paint0_linear)"
    x2="1"
    gradientUnits="userSpaceOnUse"
    gradientTransform="translate(13.0012 3.91637) scale(13.0012 3.91637) rotate(180)"
    fillOpacity="0.5"
  />
  {/*<defs>
  <linearGradient id="paint0_linear" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(13.0012 3.91637) scale(13.0012 3.91637) rotate(180)">
  <stop stop-color="#909AAA"/>
  <stop offset="1" stop-color="#7A808C"/>
  </linearGradient>
  </defs>*/}
</svg>



// WEBPACK FOOTER //
// ./src/modules/ArrowDown.js